import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hours: {
		id: 'software-cycle-time-breakdown-report.issue-chart.chart.hours',
		defaultMessage: 'Hours',
		description: 'Hours as a label for the chart y-axis',
	},
	days: {
		id: 'software-cycle-time-breakdown-report.issue-chart.chart.days',
		defaultMessage: 'Days',
		description: 'Days as a label for the chart y-axis',
	},
});
